export default __webpack_public_path__ + "static/media/1.de40fd91.png";